/**
 * Metric event types are used to identify specific metrics for generating user metric goals & scores
 * They are expected to include sub metrics such as Critical Scan from standard Unity scan events
 */
enum MetricEventTypes {
  SCAN_FREQUENCY = "SCAN_FREQUENCY",
  SCAN_TIMING = "SCAN_TIMING",
  CRITICAL_SCAN = "CRITICAL_SCAN",
  AWARENESS = "AWARENESS",
  DECISION = "DECISION",
  // Future proposed cognitive metrics
  // COGNITIVE_FLEXABILITY = "COGNITIVE_FLEXABILITY",
  // RESPONSE_INHIBITION = "RESPONSE_INHIBITION",
  // COGNITIVE_INHIBITION = "COGNITIVE_INHIBITION",
  // ATTENTION_CONTROL = "ATTENTION_CONTROL"
}

export default MetricEventTypes;
